import { computed } from 'vue'
import type { Ref } from 'vue'
import type { Row } from '@/data/types/datatable'

export function useKits<T extends { kit_components?: Row[] }>(items: Ref<T[]>) {
	const kits = computed(() => items.value.filter((item) => item.kit_components))
	return { kits } as Row
}
